import { Link } from "react-router-dom";

export default function Footer() {
  const year: number = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="grid">
          <div>
            <div className="brand">KaiserSafe</div>
            <p className="small" style={{ marginTop: 10 }}>
              © {year} KaiserSafe — kaisersafe.com
            </p>
          </div>
          <div>
            <strong>Légal</strong>
            <ul className="small" style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link to="/mentions-legales">Mentions légales</Link>
              </li>
              <li>
                <Link to="/politique-confidentialite">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/conditions-generales">Conditions générales</Link>
              </li>
            </ul>
          </div>
          <div>
            <strong>Contact</strong>
            <p className="small">
              Email :{" "}
              <a href="mailto:contact@kaisersafe.com">contact@kaisersafe.com</a>
              <br />
              Tél. : <a href="tel:+33785756439">+33 78 575 64 39</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
